import {PhoneListModalProps} from "./types";
import {Button, Empty, Modal, Skeleton} from "antd";
import useContactsController from "../../../controllers/contacts-controller";
import {useMemo} from "react";
import {CONTACT_ITEM_TYPES} from "../../../enums/contactItemTypes";
import {ArrowRightOutlined, ContactsOutlined, PhoneOutlined} from "@ant-design/icons";
import "./style.less";

const PhoneListModal = ({isOpen, onClose}: PhoneListModalProps) => {
  const {isLoading, contactsList} = useContactsController();

  const phoneItems = useMemo(() => {
    return contactsList.filter((item) => item.type === CONTACT_ITEM_TYPES.PHONE);
  }, [contactsList]);

  return <Modal
    className="phone-list-modal"
    width={640}
    centered
    title={<div className="phone-list-modal__title">
      <span className="phone-list-modal__title-icon"><ContactsOutlined/></span>
      <span>
        <span className="phone-list-modal__title-eyebrow">Швидкий зв’язок</span>
        <span className="phone-list-modal__title-text">Телефони лікарні</span>
      </span>
    </div>}
    open={isOpen}
    onCancel={onClose}
    footer={<Button className="phone-list-modal__close" onClick={onClose}>Закрити</Button>}
  >
    <p className="phone-list-modal__description">
      Оберіть потрібний підрозділ — натискання на номер одразу розпочне дзвінок.
    </p>

    {isLoading && !phoneItems.length ? <div className="phone-list-modal__loading">
      {Array.from({length: 4}).map((_, index) => <div className="phone-list-skeleton" key={index}>
        <Skeleton.Avatar active shape="square" size={44}/>
        <Skeleton active paragraph={false} title={{width: "72%"}}/>
      </div>)}
    </div> : phoneItems.length ? <div className={`phone-list ${isLoading ? "phone-list--updating" : ""}`}>
      {phoneItems.map((item) => <a className="phone-list-item" href={`tel:${item.value}`}
                                      key={item.$id || `${item.name}-${item.value}`}>
        <span className="phone-list-item__icon"><PhoneOutlined/></span>
        <span className="phone-list-item__content">
          <span className="phone-list-item__name">{item.name}</span>
          <span className="phone-list-item__number">{item.value}</span>
        </span>
        <span className="phone-list-item__action">
          <span>Зателефонувати</span>
          <ArrowRightOutlined/>
        </span>
      </a>)}
    </div> : <div className="phone-list-modal__empty">
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Телефонів поки немає"/>
    </div>}
  </Modal>;
};

export default PhoneListModal;
